<template>
  <role-edit admin />
</template>

<script>
import RoleEdit from '../RoleEdit'
export default {
  components: { RoleEdit }
}
</script>

<style></style>
